import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';

export default ({ isOpen, onClose, onSave }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader className='modal-title' style={{ position: 'relative', height: 50 }}>
                <span style={{ position: 'absolute', left: '41%' }}>Atenção</span>
            </ModalHeader>
            <ModalBody>
               <h5>Tem certeza que deseja executar essa ação?</h5>
            </ModalBody>
            <ModalFooter>
                <Button type='submit' size='md' color='danger' onClick={onSave}>
                    Sim
                </Button>
                <Button color='secondary' onClick={onClose}>
                    Não
                </Button>
            </ModalFooter>
        </Modal>
    );
};
